import { effect, inject, Injectable, Injector, untracked } from '@angular/core';

import { CharactersStore } from '@rpgc-ai/store/characters/characters.store';
import { FeedStore } from '@rpgc-ai/store/feed/feed.store';
import { ProfileStore } from '@rpgc-ai/store/profile/profile.store';

import { IS_SERVER } from '@rpgc-ai/shared-interfaces/tokens/is-server.token';

/**
 * Держит счётчик непрочитанной активности в актуальном состоянии, пока пользователь авторизован.
 * Используется shell-компонентами приложений (badge в левом сайдбаре).
 */
@Injectable({ providedIn: 'root' })
export class FeedPollingService {
  readonly #isServer = inject(IS_SERVER);
  readonly #injector = inject(Injector);
  readonly #feedStore = inject(FeedStore);
  readonly #charactersStore = inject(CharactersStore);
  readonly #profileStore = inject(ProfileStore);

  #initialized = false;

  init(): void {
    if (this.#initialized) {
      return;
    }
    this.#initialized = true;

    this.#setFeedPollingEffect();
  }

  #setFeedPollingEffect(): void {
    effect(
      () => {
        const isAuth = this.#profileStore.isAuthenticated();
        const filterNsfw =
          this.#charactersStore.filterNsfw() || this.#charactersStore.getStoredCatalogSafeSearchFilter() || this.#profileStore.nsfwFilter();

        untracked(() => {
          if (this.#isServer) {
            return;
          }

          if (isAuth) {
            this.#feedStore.pollLatest({ filterNsfw });
          } else {
            this.#feedStore.stopPolling();
          }
        });
      },
      { injector: this.#injector },
    );
  }
}
